import { injectable } from 'tsyringe'
import { RecomendationApiRepository } from '@/app/repositories/api/RecomendationApiRepository'
import { Recomendation } from '@/domain/entities/Recommendation'
import {
  PostRecomendationInterface,
  DeleteRecomendationInterface,
} from '@/data/payload/contracts/RecomendationRequest'
import { GuideCategory } from '@/domain/entities/GuideCategory'
import { GuideCategoryApiRepository } from '@/app/repositories/api/GuideCategoryRepository'
import { TrainingCategoryApiRepository } from '@/app/repositories/api/TrainingCategoryRepository'
import { TrainingCategory } from '@/domain/entities/TrainingCategory'
import { AdditionalInfoApiRepository } from '@/app/repositories/api/AdditionalInfoApiRepository'
import { AdditionalInfo } from '@/domain/entities/AdditionalInfo'
import { BulletinApiRepository } from '@/app/repositories/api/BulletinApiRepository'
import { Bulletin } from '@/domain/entities/Bulletin'
@injectable()
export class RecomendationPresenter {
  private repository: RecomendationApiRepository
  private repostoryQuickGuide: GuideCategoryApiRepository
  private repositoryTraining: TrainingCategoryApiRepository
  private repositoryAdditionalInfo: AdditionalInfoApiRepository
  private repositoryBulletin: BulletinApiRepository

  constructor(
    repository: RecomendationApiRepository,
    repostoryQuickGuide: GuideCategoryApiRepository,
    repositoryTraining: TrainingCategoryApiRepository,
    repositoryAdditionalInfo: AdditionalInfoApiRepository,
    repositoryBulletin: BulletinApiRepository
  ) {
    this.repository = repository
    this.repostoryQuickGuide = repostoryQuickGuide
    this.repositoryTraining = repositoryTraining
    this.repositoryAdditionalInfo = repositoryAdditionalInfo
    this.repositoryBulletin = repositoryBulletin
  }

  public loadRecomendation(params: Object): Promise<Recomendation> {
    return this.repository.getAll(params)
  }

  public loadGuideCategories(params: Object): Promise<GuideCategory> {
    return this.repostoryQuickGuide.getAll(params)
  }

  public loadTrainingCategories(params: Object): Promise<TrainingCategory> {
    return this.repositoryTraining.getAll(params)
  }

  public loadAdditionalInfo(params: Object): Promise<AdditionalInfo> {
    return this.repositoryAdditionalInfo.getAll(params)
  }

  public loadBulletin(params: Object): Promise<Bulletin> {
    return this.repositoryBulletin.getAll(params)
  }

  public postRecomendation(
    payload: PostRecomendationInterface
  ): Promise<Recomendation> {
    return this.repository.post(payload)
  }

  public deleteRecomendation(
    payload: DeleteRecomendationInterface
  ): Promise<Recomendation> {
    return this.repository.delete(payload)
  }
}
